import Home from "@views/Home.vue";
import ArticleList from "@views/ArticleList.vue";
import EmbedIframe from "@views/EmbedIframe.vue";
import { getParam } from "@utiles/index";

export const pageType = {
  1: {
    comp: Home,
  },
  2: {
    comp: ArticleList,
  },
  3: {
    comp: ArticleList,
  },
  // 前端特殊处理的嵌入iframe页面
  999: {
    comp: EmbedIframe,
  },
};

export const initModuleConfig = (moduleConfig) => {
  moduleConfig.forEach((item) => {
    const { MODULE_ENNAME } = item;
    const modulePath = "/" + MODULE_ENNAME;
    item.MODULE_PATH = modulePath;
  });
};

export const initRoutes = (router, moduleConfig) => {
  moduleConfig.forEach((item) => {
    const { MODULE_ENNAME, MODULE_TYPE, ID, MODULE_PATH, isIframe, iframeUrl } =
      item;
    router.addRoute({
      path: MODULE_PATH,
      component: pageType[MODULE_TYPE].comp,
      name: MODULE_ENNAME + "_" + ID,
      meta: {
        moduleName: MODULE_ENNAME,
        modulePaht: MODULE_PATH,
        isIframe: isIframe,
        iframeUrl: iframeUrl,
      },
    });
  });
};

/**
  1、进入页面，初始化全站路由信息，然后进行后面的流程
  2、链接有module，且module存在，则跳到对应页面，请求module的模块，初始化页面信息
  3、链接没有module，位于search或articledetail路由，跳转到对应路由页面，初始化页面
  4、如果路由不存在 ｜ 链接没有module，取第一个module获取MODULE_TYPE进行初始化，跳到指定路由页面
*/
export const initJumpRouter = (router, moduleConfig) => {
  if (
    !moduleConfig ||
    !Array.isArray(moduleConfig) ||
    (Array.isArray(moduleConfig) && moduleConfig.length === 0)
  ) {
    return;
  }
  const module = getParam("module");
  if (module) {
    const findModule = moduleConfig.find(
      (item) => item.MODULE_ENNAME === module
    );
    if (findModule) {
      const { MODULE_PATH } = findModule;
      router.push({
        path: MODULE_PATH,
      });
      return;
    }
  }
  let hash = window.location.hash;
  if (hash) {
    hash = hash.substring(2).split("?")[0];
    if (["articledetail", "search"].includes(hash)) {
      return;
    }
  }
  const { MODULE_PATH } = moduleConfig[0];
  router.push({
    path: MODULE_PATH,
  });
};
